import { useId, useState } from 'react';
import { Icono } from './Icono';
import './campos.css';

/**
 * RV Campo `tipo="select"` (componentes.md §8): la píldora de RV Campo con la etiqueta siempre arriba, el valor elegido y
 * la flecha a la derecha; el `<select>` del sistema abre las opciones (en móvil, la rueda nativa). Error y ayuda como RV
 * Campo.
 */
export interface OpcionDesplegable {
    valor: string;
    texto: string;
}

interface Props {
    etiqueta: string;
    valor: string;
    opciones: readonly OpcionDesplegable[];
    onChange: (valor: string) => void;
    error?: string | null;
    ayuda?: string | null;
    bloqueado?: boolean;
    nombre?: string;
    /** `oscuro` en el widget oscuro (RV Campo tipo select, G618). */
    tema?: 'claro' | 'oscuro';
}

export function Desplegable({ etiqueta, valor, opciones, onChange, error, ayuda, bloqueado = false, nombre, tema = 'claro' }: Props) {
    const idCampo = useId();
    const [foco, setFoco] = useState(false);
    const hayError = error != null && error !== '';
    const hayAyuda = !hayError && ayuda != null && ayuda !== '';
    const idNota = `${idCampo}-nota`;
    const caja = ['rv-campo__caja', 'rv-campo__caja--select', bloqueado ? 'rv-campo__caja--bloqueado' : '', foco ? 'rv-campo__caja--foco' : '', hayError ? 'rv-campo__caja--error' : ''].filter((c) => c !== '').join(' ');
    return (
        <div className={`rv-campo${tema === 'oscuro' ? ' rv-tema-oscuro' : ''}`} data-rv-tema={tema}>
            <div className="rv-campo__fila">
                <label htmlFor={idCampo} className={caja}>
                    <span className="rv-campo__etiqueta rv-campo__etiqueta--arriba">{etiqueta}</span>
                    <select
                        id={idCampo}
                        name={nombre ?? idCampo}
                        value={valor}
                        disabled={bloqueado}
                        aria-invalid={hayError}
                        aria-describedby={hayError || hayAyuda ? idNota : undefined}
                        onChange={(e) => {
                            onChange(e.target.value);
                        }}
                        onFocus={() => {
                            setFoco(true);
                        }}
                        onBlur={() => {
                            setFoco(false);
                        }}
                    >
                        {opciones.map((o) => (
                            <option key={o.valor} value={o.valor}>
                                {o.texto}
                            </option>
                        ))}
                    </select>
                    <Icono nombre="chevrons-up-down" className="rv-campo__flecha" />
                </label>
            </div>
            {hayError && (
                <span id={idNota} role="alert" className="rv-campo__error">
                    <Icono nombre="circle-alert" />
                    <span>{error}</span>
                </span>
            )}
            {hayAyuda && (
                <span id={idNota} className="rv-campo__ayuda">
                    {ayuda}
                </span>
            )}
        </div>
    );
}
